import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import Model from "@ckeditor/ckeditor5-ui/src/model";

import {
  addListToDropdown,
  createDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";

export default class PlaceholderUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    const placeholderItems = editor.config.get("placeholderProps.types") || {};

    // The "placeholder" dropdown must be registered among UI components of the editor
    // to be displayed in the toolbar.
    editor.ui.componentFactory.add("placeholder", locale => {
      const dropdownView = createDropdown(locale);

      // Populate the list in the dropdown with items.
      addListToDropdown(
        dropdownView,
        getDropdownItemsDefinitions(placeholderItems),
      );

      dropdownView.buttonView.set({
        // The t() function helps localize the editor. All strings enclosed in t() can be
        // translated and change when the language of the editor changes.
        label: t("Insert {Field}..."),
        tooltip: true,
        withText: true,
				class: "hs-placeholder-dropdown"
      });

      // Execute the command when the dropdown items is clicked (executed).
      this.listenTo(dropdownView, "execute", evt => {
        editor.execute("placeholder", {
          value: evt.source.commandParam,
        });
        editor.editing.view.focus();
      });

      return dropdownView;
    });
  }
}

function getDropdownItemsDefinitions(placeholderItems) {
  const itemDefinitions = new Collection();
	
	// for (const placeholderItem of placeholderItems) {
	for (var key in placeholderItems){
		var placeholderItem = placeholderItems[key];

    const definition = {
      type: "button",
      model: new Model({
        commandParam: placeholderItem,
        label: placeholderItem.name,
        withText: true,
      }),
    };

    // Add the item definition to the collection.
    itemDefinitions.add(definition);
  }

  return itemDefinitions;
}
